import React from 'react'
import { EpisodeIndexRecord } from '@/search/types'
import { BaseSearchHit } from './BaseSearchHit'
import { HighlightHit } from './HighlightHit'
import { ResponsiveSearchImage } from './ResponsiveSearchImage'
import { SearchHitTextBlock } from './SearchHitTextBlock'
import { BaseSearchHitProps } from './types'

export const EpisodeSearchHit: React.FC<BaseSearchHitProps<EpisodeIndexRecord>> = ({ hit }) => {
  return (
    <BaseSearchHit hit={hit}>
      <ResponsiveSearchImage src={hit.thumbnailUrl} alt={hit.projectName} />
      <SearchHitTextBlock
        label={<HighlightHit hit={hit} attribute="projectName" />}
        subLabel={<HighlightHit hit={hit} attribute="subtitle" />}
        caption={
          <>
            {hit.seasonName && (
              <>
                <HighlightHit hit={hit} attribute="seasonName" /> |{' '}
              </>
            )}
            <HighlightHit hit={hit} attribute="name" />
          </>
        }
      />
    </BaseSearchHit>
  )
}
